import { DELETED, DENIED } from '../../../../utils/constants/gigStatuses';
import { CATEGORIES, SUB_CATEGORIES } from '../../../../utils/categoriesEnum';

export const ALLOWED_CURRENT_USER_STATUS = 'active';
export const RESTRICTED_GIG_STATUS = [DELETED, DENIED];
export const ALLOWED_CATEGORIES = [ CATEGORIES.PROGRAMMING_TECH ];
export const ALLOWED_SUB_CATEGORIES = [
    SUB_CATEGORIES.VOICE_OVERS,
    SUB_CATEGORIES.SOCIAL_MARKETING,
    SUB_CATEGORIES.RESUMES_COVER_LETTERS,
    SUB_CATEGORIES.PROOFREADING,
    SUB_CATEGORIES.WEB_MOBILE_DESIGN,
    SUB_CATEGORIES.WHITEBOARD_EXPLAINER_VIDEOS
];
